import React, { useContext, useEffect } from 'react';
import { Link } from 'gatsby';
// Components
import Modal from '../modal';
import useModal from '../../hooks/useModal';
import RichTextRenderer from '../richTextRenderer';
// Interfaces
import { Link as LinkInterface } from '../../interfaces/link';
// Utils
import { slugManager } from '../../utils/SlugManager';
// State
import LanguageProvider from '../state';
import CallCostsChecker from '../../scripts/CallCostsChecker';

interface InternalExternalLinkProps {
  link: LinkInterface;
  className?: string;
  activeClassName?: string;
  // eslint-disable-next-line no-undef
  children?: JSX.Element | Array<JSX.Element | string>;
}

function InternalExternalLink({
  link,
  className,
  activeClassName,
  children,
}: InternalExternalLinkProps) {
  const { isShowing, toggle } = useModal();

  const currentLocale: string = useContext(LanguageProvider);

  const { linkedPage, externalUrl, openInNewTab, linkName, link_id, modal, extraClasses } = link;

  useEffect(() => {
    if (modal) {
      const params = new URLSearchParams(window.location.search);
      const display = params.get('display');

      if (display === 'intl_call_rates') {
        document.getElementById('InternationalCallRatesButton').click();
      } else if (display === 'cost_checker') {
        document.getElementById('CostCheckerButton').click();
      }
    }
  }, []);

  return (
    <React.Fragment>
      {externalUrl ? (
        <>
          <a
            href={modal ? 'javascript:void(0)' : externalUrl}
            className={`${modal ? 'cl-modal__link' : ''} ${extraClasses ? extraClasses : ''} ${
              className ? className : ''
            } `}
            target={openInNewTab ? '_blank' : '_self'}
            rel='noreferrer'
            onClick={modal ? toggle : () => null}
            aria-label={linkName ? linkName : 'Find out more'}
            id={link_id}
          >
            {children ? children : link.linkName}
          </a>
          {modal ? (
            <Modal
              isShowing={isShowing}
              hide={toggle}
              modalType={modal.modalType}
              align={modal.align}
            >
              {modal.title && (
                <header className='cl-modal__header'>
                  <h3 className='cl-h4'>{modal.title}</h3>
                </header>
              )}
              <div className='cl-modal__content'>
                <RichTextRenderer text={modal.content} />
                {modal.modalId === 'callCosts' && <CallCostsChecker />}
              </div>
            </Modal>
          ) : null}
        </>
      ) : (
        <Link
          to={slugManager(linkedPage.slug, currentLocale)}
          className={`${extraClasses ? extraClasses : ''} ${className ? className : ''}`}
          activeClassName={activeClassName ? activeClassName : ''}
          aria-label={linkName ? linkName : 'Find out more'}
        >
          {children ? children : link.linkName}
        </Link>
      )}
    </React.Fragment>
  );
}

export default InternalExternalLink;
